export const UPDATE_COUNTER = "__UPDATE_COUNTER__";
export const UPDATE_CURRENT_USER = "__UPDATE_CURRENT_USER__";
export const STORES_CHANGED = "STORES_CHANGES";
